import React, { useEffect } from 'react';
import HeroSliderNew from '../components/HeroSliderNew';
import AboutSectionSummary from '../components/AboutSectionSummary';
import ServicesSliderNew from '../components/ServicesSliderNew';
import WhyChooseUsNew from '../components/WhyChooseUsNew';
import SpiralProjectsNew from '../components/SpiralProjectsNew';

function HomePageNew({ onNavigate, setScrollCounter }) {
  useEffect(() => {
    // Reveal on scroll
    const reveal = () => {
      const reveals = document.querySelectorAll(".reveal");
      reveals.forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        if (elementTop < windowHeight - 100) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal();

    return () => {
      window.removeEventListener("scroll", reveal);
    };
  }, []);

  const handleProjectClick = (projectId) => {
    onNavigate('project-detail', null, projectId);
  };

  const handleSeeAllClick = () => {
    onNavigate('projects_page');
  };

  return (
    <div id="home-view" className="view-section transition-all duration-500">
      <HeroSliderNew onNavigate={onNavigate} />
      <AboutSectionSummary />
      <ServicesSliderNew />
      <WhyChooseUsNew />
      <SpiralProjectsNew 
        onProjectClick={handleProjectClick}
        onSeeAllClick={handleSeeAllClick}
        setScrollCounter={setScrollCounter}
      />
    </div>
  );
}

export default HomePageNew;
